import router from '@/router';
import store from '@/store';

import { FIELD_NAMES } from '@/forms/constants/nbc-logic';

import {
  CHANGE_VALUE_FIELD,
} from '@/lib/constants/mutations';

export default ({ rewardType, storeValueCard }) => {
  let fieldsToChange = [
    {
      name: FIELD_NAMES.rewards,
      value: rewardType,
    },
    {
      name: FIELD_NAMES.spending,
      value: 'Deferring payments',
    },
  ];

  let stepToGo = 'income-step';

  if (storeValueCard) {
    fieldsToChange = [
      {
        name: FIELD_NAMES.spending,
        value: 'Paying straight away',
      },
    ];

    stepToGo = 'salary-step';
  }

  return {
    render(h) {
      return h('div');
    },

    created() {
      fieldsToChange.forEach(({ name, value }) => {
        store.commit(
          CHANGE_VALUE_FIELD,
          {
            name,
            newValue: value,
            newValidationStates: [],
            edited: true,
          },
        );
      });

      router.goToFormByName(
      'Deem | Credit Card', // 'NBC Card',
        {
          stepNameToInit: stepToGo,
        },
      );
    },
  };
};
